export default __webpack_public_path__ + "static/media/icon_map.303b2787.svg";